import List from '../../list';
import MediaProduction from '@shared/classes/mediaProduction';
import HorizontalCard from '../../../../elements/card/horizontalCard';
import RailProps from '../../../../../../shared/types/props/rail';
import goToContent from '../../../../../../shared/actions/content/goToContent';
import FastEvent from '@shared/classes/fastEvent';

export default function RecommendationsRail({ list }: RailProps) {
  const { data, focus, onClick } = list;
  return (
    <List {...list}>
      {(data as (MediaProduction | FastEvent | undefined)[])?.map(
        (item: MediaProduction | FastEvent | undefined, index: number) => {
          return (
            <HorizontalCard
              key={index}
              item={item as MediaProduction | FastEvent}
              index={index}
              onClick={() => onClick(item, index, focus)}
              releaseAction={() => goToContent(item)}
            />
          );
        }
      )}
    </List>
  );
}
